import React from 'react';
import Box from '@mui/material/Box';
import { IconButton, TextField, Tooltip } from '@mui/material';
import { LocalizationProvider, MobileDateTimePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { ClearIcon } from 'components/icons';
import { parseApiDateTime } from 'utils/dateUtils';

interface CheckpointDateTimeResponseProps {
  value: string | null; // ISO string
  onChange: (newValue: string | null) => void;
}

const CheckpointDateTimeResponse: React.FC<CheckpointDateTimeResponseProps> = ({
  value,
  onChange,
}) => {
  const handleChange = (date: Date | null) => {
    onChange(date ? date.toISOString() : null);
  };

  return (
    <Box sx={{ display: 'flex', gap: '0.5rem' }}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <MobileDateTimePicker
          value={value ? parseApiDateTime(value) : null}
          onChange={handleChange}
          inputFormat="EEE dd MMM h:mm a"
          maxDateTime={new Date()}
          renderInput={(params) => <TextField {...params} />}
        />
      </LocalizationProvider>

      <Tooltip title="Set to current date/time">
        <IconButton onClick={() => handleChange(new Date())}>
          <AccessTimeIcon />
        </IconButton>
      </Tooltip>
      <Tooltip title="Clear">
        <IconButton onClick={() => handleChange(null)}>
          <ClearIcon />
        </IconButton>
      </Tooltip>
    </Box>
  );
};

export default CheckpointDateTimeResponse;
